import { Component, OnInit } from '@angular/core';

import { AlertService } from './alert.service';

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html'
})

export class AlertComponent {
    message: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getMessage().subscribe(message => { 
            this.message = message;
        });
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/alert/alert.component.ts